import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProgressAttribute.css';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

const ProgressAttribute = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  const [progress, setProgress] = useState([]);
  const urlParams = new URLSearchParams(location.search);
  const sportId = urlParams.get('sportId');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const token = localStorage.getItem('auth-token');
  useEffect(() => {
    if (sportId) {
      setLoading(true);
      setError(null);

      const headers = {
        'Authorization': `Bearer ${token}`,
      };

      fetch(`${process.env.REACT_APP_API_ADMIN_SPORT_PROGRESS_ATTRIBUTE}?sportId=${sportId}`, {
        method: 'GET',
        headers: headers,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((text) => {
          setLoading(false);

          if (!text || text.trim() === "null") {
            setProgress([]);
            return;
          }

          try {
            const data = JSON.parse(text);

            if (data.success && data.data?.progressAttributes) {
              setProgress(
                data.data.progressAttributes.map((item) => ({
                  id: item.id,
                  name: item.name,
                  description: item.description,
                }))
              );
            } else {
              setProgress([]);
            }
          } catch (error) {
            setProgress([]);
          }
        })
        .catch((error) => {
          setLoading(false);
          setError("Error fetching data: " + error.message);
        });

    }
  }, [sportId]);
  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  const handleDelete = (progressId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_API_ADMIN_DELETE_PROGRESS_ATTRIBUTE}/${progressId}/${sportId}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Progress attribute deleted successfully!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
              });

              setProgress(progress.filter((prog) => prog.id !== progressId));
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete progress attribute!',
              });
            }
          })
          .catch(() => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'An error occurred while deleting!',
            });
          });
      }
    });
  };


  const [dropdownOpen, setDropdownOpen] = useState(null);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };
  const handleCreateCourt = (event) => {
    if (!sportId) return;
  
    const url = `/newProgress?sportId=${sportId}`;
    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };
  
  const handleEdit = (event, progId) => {
    const url = `/newProgress?sportId=${sportId}&progressAttributeId=${progId}`;

    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };

  const handleprogessparameter = (event, progId) => {
    const url = `/ProgessParameter?sportId=${sportId}&progressAttributeId=${progId}`;

    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };

  const handleProgessQa = (event, progId) => {
    const url = `/AttributeQa?sportId=${sportId}&progressAttributeId=${progId}`;

    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };


  const filteredProgress = progress.filter((prog) =>
    Object.values(prog)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredProgress.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredProgress.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };
  const dropdownRef = useRef(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

  const toggleDropdown = (progId, e) => {
    e.stopPropagation();
    if (dropdownOpen === progId) {
      return setDropdownOpen(null);
    }
    const { bottom, left } = e.currentTarget.getBoundingClientRect();
    setDropdownPos({
      top: bottom + window.scrollY,
      left: left + window.scrollX,
    });
    setDropdownOpen(progId);
  };
  useEffect(() => {
    const closeOnScroll = () => setDropdownOpen(null);

    window.addEventListener('scroll', closeOnScroll, true);
    return () => window.removeEventListener('scroll', closeOnScroll, true);
  }, []);
  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector('.custom-dropdown-player');
      if (dropdown && !dropdown.contains(event.target) && !event.target.closest('.dots-btn-player')) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const totalEntries = filteredProgress.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;
  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/sportList" className="breadcrumb-link">Sport List</Link> &gt; Progress Attribute
      </div>
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>

        <button
          className="create-button-new"
          onClick={handleCreateCourt}
        >
          <span className="create-button__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="23"
              height="23"
              className="create-button__svg"
            >
              <path
                d="M12 5v14M5 12h14"
                stroke="white"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="create-button__label">
            Create Attribute
          </span>
        </button>
      </div>
      <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
        <option value={10}>10 items per page</option>
        <option value={50}>50 items per page</option>
        <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
        <div className="button-group">
          <div className="group-label">Items per page:</div>
          <div className="button-options">
            {[10, 50, 75, 100].map((option) => (
              <button
                key={option}
                onClick={() =>
                  handleItemsPerPageChange({ target: { value: option } })
                }
                className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
              >
                <span className="button-text">{option}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredProgress.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      <div className="payment-list-scroll-container" style={{ overflow: 'visible' }}>
        <table className="payment-list-table">

          <thead>
            <tr className="progressattribute-header-row">
              <th>Name</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((prog) => (
              <tr key={prog.id} className="progressattribute-row">
                <td >{prog.name}</td>
                <td >{prog.description}</td>
                <td className="sport-actions-column">
                  <button
                    className="dots-btn-player"
                    type="button"
                    onClick={(e) => toggleDropdown(prog.id, e)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '24px',
                    }}
                  >
                    &#x22EE;
                  </button>

                  {dropdownOpen === prog.id && (
                    <div
                      className="custom-dropdown-player"
                      style={{
                        position: 'absolute',
                        top: dropdownPos.top,
                        left: dropdownPos.left,
                        zIndex: 9999,
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                        minWidth: '180px',
                      }}
                    >
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={(e) => handleEdit(e, prog.id)}
                      >
                        Edit
                      </button>

            

                        <button
                          type="button"
                          className="dropdown-item"
                          onClick={() => handleDelete(prog.id)}
                        >
                          Delete
                        </button>
                        <button
                        type="button"
                        className="dropdown-item"
                        onClick={(e) => handleprogessparameter(e, prog.id)}
                      >
                        Progress Parameter
                      </button>

                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={(e) => handleProgessQa(e, prog.id)}
                      >
                        Progress QA
                      </button>

                    </div>
                  )}
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ProgressAttribute;
